<template>
    <div>
        <div class="form-row justify-content-start">
            <div class="col-sm-3">
                <div class="form-group">
                    <label for="name">Cpf / Cnpj</label>
                    <the-mask type="tel" placeholder="Digite o cpf ou cnpj" v-model="value.documentNumber" v-validate="modelValidations.documentNumber" :class="{'form-control': true, 'is-invalid': errors.has('documentNumber')}" data-vv-name="documentNumber" data-vv-as="cpf / cnpj" :mask="['###.###.###-##', '##.###.###/####-##']" :disabled="isCustomerDocumentDisabled" />
                    <div v-show="errors.has('documentNumber')" class="invalid-feedback">
                        {{ errors.first('documentNumber') }}
                    </div>
                    <input type="hidden" ref="sellerType" v-model="value.type" />
                </div>
            </div>            
        </div>
        <div class="form-row justify-content-start">
            <div class="col-sm-4">
                <div class="form-group">
                    <label for="name">Nome</label>
                    <input type="text" placeholder="Digite o nome da empresa" v-model="value.name" v-validate="modelValidations.name" :class="{'form-control': true, 'is-invalid': errors.has('name')}" data-vv-name="name" data-vv-as="nome" maxlength="150" />
                    <div v-show="errors.has('name')" class="invalid-feedback">
                        {{ errors.first('name') }}
                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="form-group" v-if="!$auth.isSalesPerson">
                    <label for="exampleFormControlSelect12">Contrato</label>
                    <select :class="{'form-control': true, 'is-invalid': errors.has('contractId')}" v-validate="modelValidations.contractId" v-model="value.contractId" data-vv-name="contractId" data-vv-as="contrato">
                        <option v-for="(contract, index) in contractList" :key="index" :value="contract.id">
                            {{contract.name}}
                        </option>
                    </select>
                    <div v-show="errors.has('contractId')" class="invalid-feedback">
                        {{ errors.first('contractId') }}
                    </div>
                </div>
            </div>            
        </div>        
        <div v-show="sellerType == 'F'">
            <div class="form-row justify-content-start">
                <div class="col-sm-3">
                    <div class="form-group">
                        <label for="name">RG</label>
                        <the-mask type="tel" v-validate.immediate="'required_if:sellerType,F'" placeholder="Digite o RG" v-model="value.identityDocument" v-validate="modelValidations.identityDocument" :class="{'form-control': true, 'is-invalid': errors.has('identityDocument')}" data-vv-name="identityDocument" data-vv-as="RG" :mask="['##.###.###-#']" />
                        <div v-show="errors.has('identityDocument')" class="invalid-feedback">
                            {{ errors.first('identityDocument') }}
                        </div>
                    </div>
                </div>            
                <div class="col-sm-2">
                    <div class="form-group">
                        <label for="exampleFormControlSelect12">Gênero</label>
                        <select :class="{'form-control': true, 'is-invalid': errors.has('gender')}" v-validate.immediate="'required_if:sellerType,F'" v-validate="modelValidations.gender" v-model="value.gender" data-vv-name="gender" data-vv-as="gênero">
                            <option v-for="(gender, index) in genderList" :key="index" :value="gender.id">
                                {{gender.name}}
                            </option>
                        </select>
                        <div v-show="errors.has('gender')" class="invalid-feedback">
                            {{ errors.first('gender') }}
                        </div>
                    </div>
                </div>                
            </div>
        </div>
        <div v-show="sellerType == 'J'">        
            <div class="form-row justify-content-start">  
                <div class="col-sm-4">
                    <div class="form-group">
                        <label for="name">Razão social</label>
                        <input ref="documentType" type="hidden" v-model="value.type" />
                        <input type="text" placeholder="Digite a razão social" v-validate.immediate="'required_if:documentType,J'" v-model="value.socialName" v-validate="modelValidations.socialName" :class="{'form-control': true, 'is-invalid': errors.has('socialName')}" data-vv-name="socialName" data-vv-as="razão social" maxlength="350" />
                        <div v-show="errors.has('socialName')" class="invalid-feedback">
                            {{ errors.first('socialName') }}
                        </div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="form-group">
                        <label for="name">Cnae</label>
                        <select :class="{'form-control': true, 'is-invalid': errors.has('cnae')}" v-validate="modelValidations.cnae" v-model="value.cnae" data-vv-name="cnae" data-vv-as="Cnae">
                            <option v-for="(cnae, index) in cnaeList" :key="index" :value="cnae.cod">
                                {{cnae.desc}}
                            </option>
                        </select>                                    
                        <div v-show="errors.has('cnae')" class="invalid-feedback">
                            {{ errors.first('cnae') }}
                        </div>
                    </div>
                </div>
            </div>
            <h5 class="mt-3">Dados do responsável</h5>
            <hr class="mb-3" />
            <div class="form-row justify-content-start">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label for="name">Nome</label>
                        <input type="text" v-validate.immediate="'required_if:sellerType,J'" placeholder="Digite o nome do responsável" v-model="value.owner.name" v-validate="modelValidations.owner.name" :class="{'form-control': true, 'is-invalid': errors.has('owner.name')}" data-vv-name="owner.name" data-vv-as="nome" maxlength="150" />
                        <div v-show="errors.has('owner.name')" class="invalid-feedback">
                            {{ errors.first('owner.name') }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-row justify-content-start">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label for="name">Cpf</label>
                        <the-mask type="tel" v-validate.immediate="'required_if:sellerType,J'" placeholder="Digite o cpf" v-model="value.owner.documentNumber" v-validate="modelValidations.owner.documentNumber" :class="{'form-control': true, 'is-invalid': errors.has('owner.documentNumber')}" data-vv-name="owner.documentNumber" data-vv-as="cpf" :mask="['###.###.###-##']" />
                        <div v-show="errors.has('owner.documentNumber')" class="invalid-feedback">
                            {{ errors.first('owner.documentNumber') }}
                        </div>
                    </div>
                </div>            
                <div class="col-sm-4">
                    <div class="form-group">
                        <label for="name">E-mail</label>
                        <input type="email" v-validate.immediate="'required_if:sellerType,J'" placeholder="Digite seu e-mail" v-model="value.owner.email" v-validate="modelValidations.owner.email" :class="{'form-control': true, 'is-invalid': errors.has('owner.email')}" data-vv-name="owner.email" data-vv-as="e-mail" maxlength="255" />
                        <div v-show="errors.has('owner.email')" class="invalid-feedback">
                            {{ errors.first('owner.email') }}
                        </div>
                    </div>
                </div>                
            </div>
            <div class="form-row justify-content-start">
                <div class="col-sm-1">
                    <div class="form-group">
                        <label for="name">DDD</label>
                        <the-mask type="tel" v-validate.immediate="'required_if:sellerType,J'" placeholder="DDD" v-model="value.owner.phone.areaCode" v-validate="modelValidations.owner.areaCode" :class="{'form-control': true, 'is-invalid': errors.has('owner.areaCode')}" data-vv-name="owner.areaCode" data-vv-as="DDD" :mask="['##']" />
                        <div v-show="errors.has('owner.areaCode')" class="invalid-feedback">
                            {{ errors.first('owner.areaCode') }}
                        </div>
                    </div>
                </div>
                <div class="col-sm-2">
                    <div class="form-group">
                        <label for="name">Telefone</label>                                    
                        <the-mask type="tel" v-validate.immediate="'required_if:sellerType,J'" placeholder="Digite seu telefone" v-model="value.owner.phone.number" v-validate="modelValidations.owner.phoneNumber" :class="{'form-control': true, 'is-invalid': errors.has('owner.phoneNumber')}" data-vv-name="owner.phoneNumber" data-vv-as="telefone" :mask="['####-####', '#####-####']" />
                        <div v-show="errors.has('owner.phoneNumber')" class="invalid-feedback">
                            {{ errors.first('owner.phoneNumber') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-row justify-content-start">
            <div class="col-sm-2">
                <div class="form-group">
                    <label for="status">Status</label>
                    <select :class="{'form-control': true, 'is-invalid': errors.has('status')}" v-validate="modelValidations.status" v-model="value.status" data-vv-name="status" data-vv-as="Status">
                        <option v-for="(item, index) in statusList" :key="index" :value="item.status">
                            {{item.name}}
                        </option>
                    </select>                                    
                    <div v-show="errors.has('status')" class="invalid-feedback">
                        {{ errors.first('status') }}
                    </div>
                </div>
            </div>
        </div>
        <h5 class="mt-3">Contato</h5>
            <hr class="mb-3" />
        <div class="form-row">
            <div class="col-sm-4">
                <div class="form-group">
                    <label for="name">E-mail</label>
                    <input type="email" placeholder="Digite seu e-mail" v-model="value.email" v-validate="modelValidations.email" :class="{'form-control': true, 'is-invalid': errors.has('email')}" data-vv-name="email" data-vv-as="e-mail" maxlength="255" />
                    <div v-show="errors.has('email')" class="invalid-feedback">
                        {{ errors.first('email') }}
                    </div>
                </div>
            </div>
        </div>
        <div class="form-row justify-content-start">
            <div class="col-sm-1">
                <div class="form-group">
                    <label for="name">DDD</label>
                    <the-mask type="tel" placeholder="DDD" v-model="value.phone.areaCode" v-validate="modelValidations.areaCode" :class="{'form-control': true, 'is-invalid': errors.has('areaCode')}" data-vv-name="areaCode" data-vv-as="DDD" :mask="['##']" />
                    <div v-show="errors.has('areaCode')" class="invalid-feedback">
                        {{ errors.first('areaCode') }}
                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="form-group">
                    <label for="name">Telefone</label>                                    
                    <the-mask type="tel" placeholder="Digite seu telefone" v-model="value.phone.number" v-validate="modelValidations.phoneNumber" :class="{'form-control': true, 'is-invalid': errors.has('phoneNumber')}" data-vv-name="phoneNumber" data-vv-as="telefone" :mask="['####-####', '#####-####']" />
                    <div v-show="errors.has('phoneNumber')" class="invalid-feedback">
                        {{ errors.first('phoneNumber') }}
                    </div>
                </div>
            </div>
        </div>        
        <h4 class="mt-3">Endereço</h4>
        <hr class="mb-3"/>
        <div class="form-row">
            <div class="col-sm-2 justify-content-start">
                <div class="form-group">
                    <label for="name">Cep</label>
                    <the-mask type="tel" placeholder="Digite seu Cep" v-model="value.address.zipCode" v-validate="modelValidations.zipCode" :class="{'form-control': true, 'is-invalid': errors.has('zipCode')}" data-vv-name="zipCode" data-vv-as="cep" :mask="['#####-###']" />
                    <div v-show="errors.has('zipCode')" class="invalid-feedback">
                        {{ errors.first('zipCode') }}
                    </div>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="col-sm-8">
                <div class="form-group">
                    <label for="name">Logradouro</label>
                    <input type="text" placeholder="Digite o endereço" v-model="value.address.street" v-validate="modelValidations.street" :class="{'form-control': true, 'is-invalid': errors.has('street')}" data-vv-name="street" data-vv-as="endereço" maxlength="255" />
                    <div v-show="errors.has('street')" class="invalid-feedback">
                        {{ errors.first('street') }}
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="form-group">
                    <label for="name">Numero</label>
                    <input type="text" placeholder="Digite o numero" v-model="value.address.number" v-validate="modelValidations.number" :class="{'form-control': true, 'is-invalid': errors.has('number')}" data-vv-name="number" data-vv-as="número" maxlength="20" />
                    <div v-show="errors.has('number')" class="invalid-feedback">
                        {{ errors.first('number') }}
                    </div>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="col-sm-4">
                <div class="form-group">
                    <label for="name">Complemento</label>
                    <input type="text" placeholder="Digite o complemento" v-model="value.address.complement" :class="{'form-control': true}" maxlength="250" />
                </div>
            </div>
            <div class="col-sm-4">
                <div class="form-group">
                    <label for="name">Bairro</label>
                    <input type="text" placeholder="Digite o bairro" v-model="value.address.district" v-validate="modelValidations.district" :class="{'form-control': true, 'is-invalid': errors.has('district')}" data-vv-name="district" data-vv-as="bairro" maxlength="250" />
                    <div v-show="errors.has('district')" class="invalid-feedback">
                        {{ errors.first('district') }}
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="form-group">
                    <label for="name">Cidade</label>
                    <input type="text" placeholder="Digite a cidade" v-model="value.address.city" v-validate="modelValidations.city" :class="{'form-control': true, 'is-invalid': errors.has('city')}" data-vv-name="city" data-vv-as="cidade" maxlength="250" />
                    <div v-show="errors.has('city')" class="invalid-feedback">
                        {{ errors.first('city') }}
                    </div>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="col-sm-2 justify-content-start">
                <div class="form-group">
                    <label for="stateSelect">Estado</label>
                    <select :class="{'form-control': true, 'is-invalid': errors.has('state')}" v-validate="modelValidations.state" v-model="value.address.state" data-vv-name="state" data-vv-as="estado">
                        <option value="">Selecione um estado:</option>
                        <option v-for="(s, index) in stateList" :key="index" :value="s">
                            {{s}}
                        </option>
                    </select>
                    <div v-show="errors.has('state')" class="invalid-feedback">
                        {{ errors.first('state') }}
                    </div>
                </div>
            </div>
        </div>
        <h4 class="mt-3">Dados do adquirente</h4>
        <hr class="mb-3" />
        <div class="form-row">
            <div class="col-sm-3">
                <div class="form-group">
                    <div class="custom-control custom-switch">
                        <input ref="usePartnerSettings" :disabled="$auth.isSalesPerson" type="checkbox" class="custom-control-input" v-model="value.usePartnerAcquirerSettings" id="customSwitch21">
                        <label class="custom-control-label" for="customSwitch21">Usar configuração padrão?</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="col-sm-5">
                <base-input v-validate.immediate="'required_if:usePartnerSettings,0'" :disabled="$auth.isSalesPerson || value.usePartnerAcquirerSettings" type="text" label="E-mail" required placeholder="" v-model="value.acquirerSettings.username" v-validate="modelValidations.acquirerSetting.username" data-vv-name="acquirerSetting.username" data-vv-as="usuário" maxlength="255" :error="getError('acquirerSetting.username')" />
            </div>
            <div class="col-sm-7">
                <base-input v-validate.immediate="'required_if:usePartnerSettings,0'" :disabled="$auth.isSalesPerson || value.usePartnerAcquirerSettings" type="text" label="Token" required placeholder="" v-model="value.acquirerSettings.token" v-validate="modelValidations.acquirerSetting.token" data-vv-name="acquirerSetting.token" data-vv-as="Token" maxlength="255" :error="getError('acquirerSetting.token')" />
            </div>
        </div>                            
        <div class="form-row">
            <div class="col-sm-6 justify-content-start">
                <template v-if="value.acquirerSettings.endPoint != ''">
                    <base-input disabled type="text" label="Url Notificação" placeholder="" v-model="value.acquirerSettings.endPoint" maxlength="255" />
                </template>
                <template v-else>
                    <div>{{value.usePartnerAcquirerSettings ? defaultAcquirerSettings.endPoint : value.acquirerSettings.endPoint == ''? 'Url será configurada após o cadastro.' : value.acquirerSettings.endPoint }}</div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import partnerService from '../../services/Customer/partnerService'
import contractService from '../../services/Contracts/contractService'
import helperService from '../../services/Helper/helperService'
import eventbus from '../../eventBus'
export default {
    name:'seller-input',
    inject: ['$validator'],
    props: {
        value: {
            type: Object,
            default: {
                usePartnerAcquirerSettings: false,
                name: '',
                socialName: '',
                documentNumber: '',
                identityDocument: null,
                gender: null,
                birthDate: null,
                owner: {
                    name: '',
                    documentNumber: '',
                    identityDocument: '',
                    email: '',
                    phone: {
                        areaCode: '',
                        number: ''
                    }    
                },
                cnae: null,
                phone: {
                    areaCode: '',
                    number: ''
                },
                email: '',
                status: null,
                id: '',
                type: 'F',
                salesPersonId: null,
                contractId: null,
                address: {
                    street: '',
                    number: '',
                    complement: '',
                    district: '',
                    state: '',
                    city: '',
                    zipCode: '',
                    type: ''
                },                
                acquirerSettings: {
                    username: '',
                    token: '',
                    endPoint: ''
                }
            }
        },
        action: {
            type: String
        }
    },
    data() {
        return {
            stateList: [
                'AC',
                'AL',
                'AM',
                'AP',
                'BA',
                'CE',
                'DF',
                'ES',
                'GO',
                'MA',
                'MG',
                'MS',
                'MT',
                'PA',
                'PB',
                'PE',
                'PI',
                'PR',
                'RJ',
                'RN',
                'RO',
                'RR',
                'RS',
                'SC',
                'SE',
                'SP',
                'TO'
            ],
            contractList: [],
            cnaeList:[],
            statusList: [
                {
                    status: null,
                    name: 'Selecione'
                },
                {
                    status: 'ACTIVE',
                    name: 'Ativo'
                },
                {
                    status: 'INACTIVE',
                    name: 'Inativo'
                },
                {
                    status: 'BLOCKED',
                    name: 'Bloqueado'
                }
            ],
            genderList: [
                {
                    id: null,
                    name: 'Selecione'
                },
                {
                    id: 'MALE',
                    name: 'Masculino'
                },
                {
                    id: 'FEMALE',
                    name: 'Feminino'
                },
                {
                    id: 'OTHER',
                    name: 'Outro'
                }
            ],
            defaultAcquirerSettings: {
                username: '',
                token: '',
                endPoint: ''
            },
            modelValidations: {
                name: {
                    required: true,
                    max: 150
                },
                socialName: {
                    required: true,
                    max: 155
                },
                documentNumber: {
                    required: true,
                },
                identityDocument: {
                    required_if: 'sellerType,F'
                },                
                gender: {
                    required_if: 'sellerType,F'
                },
                cnae: {
                    required_if: 'sellerType,J'
                },
                email: {
                    required: true,
                    email: true
                },
                areaCode: {
                    required: true,
                },
                phoneNumber: {
                    required: true,
                },
                status: {
                    required: true,
                },
                contractId: {
                    required: true
                },
                street: {
                    required: true,
                },
                number: {
                    required: true,
                },
                district: {
                    required: true,
                },
                state: {
                    required: true,
                },
                city: {
                    required: true,
                },
                zipCode: {
                    required: true,
                },
                acquirerSetting: {
                    username: {
                        required_if: 'usePartnerSettings,0'
                    },
                    token: {
                        required_if: 'usePartnerSettings,0'
                    }
                },
                owner: {
                    name: {
                        required_if: 'sellerType,J'
                    },
                    documentNumber: {
                        required_if: 'sellerType,J'
                    },
                    email: {
                        required_if: 'sellerType,J',
                        email: true
                    },
                    areaCode: {
                        required_if: 'sellerType,J'
                    },
                    phoneNumber: {
                        required_if: 'sellerType,J'
                    },
                }
            }
        }
    },
    watch: {        
        'value.address.zipCode': function(value) {
            if (value && value.length == 8) {
                this.getAddressData(value)
            }
        },
        'value.type': function(value) {
            if(value == 'F') {
                this.value.socialName = this.value.name
            }
            eventbus.$emit('sellerInput:documentTypeChanged', this.value.type)
        },          
        'value.documentNumber': function(value) {
            this.value.type = this.value.documentNumber.length <= 11 ? 'F' : 'J'            
        },        
        'value.usePartnerAcquirerSettings': function(value) {
            if(value) {
                this.value.acquirerSettings.token = this.defaultAcquirerSettings.token;
                this.value.acquirerSettings.endPoint = this.defaultAcquirerSettings.endPoint;
                this.value.acquirerSettings.username = this.defaultAcquirerSettings.username;
            }
            else {
                this.value.acquirerSettings.token = ''
                this.value.acquirerSettings.username = ''
                this.value.acquirerSettings.endPoint = ''
            }            
        },
        value() {
            this.$emit('input', this.value);
            eventbus.$emit('sellerInput:documentTypeChanged', this.value.type)
        }           
    },
    computed: {
        sellerType() {
            return this.value.type
        },
        isCustomerDocumentDisabled() {
            return this.action == 'edit_seller' && !this.$auth.isPartner
        }
    },
    created() {
        this.fetchData()
    },
    methods: {
        async fetchData() {
            const self = this

            let partnerResponse = await partnerService.current();
            this.defaultAcquirerSettings = partnerResponse.data.acquirerSettings;
            
            //this.showLoading()
            contractService.all().then((response) =>{
                self.contractList = response.status == 204 ? [] : response.data
                self.contractList.unshift({ id: null, name: 'Selecione um contrato'})
                //self.hideLoading()
            }, () => {
                //self.hideLoading()
            })
            
            //this.showLoading()
            helperService.cnaeGetList().then((response) =>{
                self.cnaeList = response.status == 204 ? [] : response.data
                self.cnaeList.unshift({ cod: null, desc: 'Selecione um cnae'})
                //self.hideLoading()
            }, () => {
                //self.hideLoading()
            })
        },
        getError(fieldName) {
            return this.errors.first(fieldName)
        },
        getAddressData(zipCode) {
            const self = this;            
            helperService.getAddressFromZipCode(zipCode).then(
                response => {
                    if(response && response.erro) {                        
                        return;
                    }
                    if(self.action == 'edit_seller' && response.logradouro == '') {
                        return;
                    }
                    self.value.address.street = response.logradouro
                    self.value.address.complement = response.complemento
                    self.value.address.district = response.bairro
                    self.value.address.city = response.localidade
                    self.value.address.state = response.uf                    
                },
                () => {
                    
                }
            )
        }
    }
}
</script>